export default __webpack_public_path__ + "static/tablet-48a0b756e22e02d5c396780ab624ac99.png";